/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@ngx-translate/core/src/translate.pipe';
import * as import2 from '@ngx-translate/core/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '../../../app/activation/confirm.component';
import * as import5 from '../../../app/services/activation.service';
import * as import6 from '@angular/router';
import * as import7 from 'angular2-notifications/src/notifications.service';
import * as import8 from '../../../app/services/response.service';
const styles_ActivationComponent:any[] = ([] as any[]);
export const RenderType_ActivationComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ActivationComponent,
  data: {}
}
);
function View_ActivationComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'span',[[
        'class',
        'text-success'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ACTIVATION.SUCCESS'));
    ck(v,1,0,currVal_0);
  });
}
function View_ActivationComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'span',[[
        'class',
        'error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ACTIVATION.ERROR'));
    ck(v,1,0,currVal_0);
  });
}
function View_ActivationComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'span',[[
        'class',
        'text-info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ACTIVATION.LOADING'));
    ck(v,1,0,currVal_0);
  });
}
export function View_ActivationComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'section',[[
        'class',
        'login-page long'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ActivationComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ActivationComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ActivationComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.ActivationComponent = v.component;
    const currVal_1:any = (co.activationService.activateStatus === true);
    ck(v,11,0,currVal_1);
    const currVal_2:any = (co.activationService.activateStatus === false);
    ck(v,14,0,currVal_2);
    const currVal_3:any = (co.activationService.activateStatus === (null as any));
    ck(v,17,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform('GENERAL.ACTIVATION_ACCOUNT'));
    ck(v,7,0,currVal_0);
  });
}
function View_ActivationComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_ActivationComponent_0,RenderType_ActivationComponent)),
    import0.ɵdid(114688,(null as any),0,import4.ActivationComponent,[
      import5.ActivationService,
      import6.Router,
      import6.ActivatedRoute,
      import7.NotificationsService,
      import2.TranslateService,
      import8.ResponseService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ActivationComponentNgFactory:import0.ComponentFactory<import4.ActivationComponent> = import0.ɵccf('app-main',import4.ActivationComponent,View_ActivationComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/activation/confirm.component.ngfactory.ts